<template lang="jade">
  include ./mixin.jade
  +simpleGetButton('dxGetPowerStatus')
  //- =============== dxEnableBank =============================
  .row
    .col-xs-12
      fieldset
        legend dxEnableBank
        div(v-for="(key, val) in apis.dxEnableBank.params.banks" track-by="$index")
          span(v-if="key") Bank {{ key }} :
          span(v-else) Input :
          input(type='checkbox' v-model='val')
        div
          span Enabled:
          input(type='checkbox' v-model='apis.dxEnableBank.params.enabled')

        button(@click="dxEnableBank") dxEnableBank
  //- ================ dxLockBank =============================
  .row
    .col-xs-12
      fieldset
        legend dxLockBank
        div(v-for="(key, val) in apis.dxLockBank.params.banks" track-by="$index")
          span(v-if="key") Bank {{ key }} :
          span(v-else) Input :
          input(type='checkbox' v-model='val')
        div
          span locked:
          input(type='checkbox' v-model='apis.dxLockBank.params.locked')

        button(@click="dxLockBank") dxLockBank
  //- ================ dxResetBank =============================
  .row
    .col-xs-12
      fieldset
        legend dxResetBank
        div(v-for="(key, val) in apis.dxResetBank.params.banks" track-by="$index")
          span(v-if="key") Bank {{ key }} :
          span(v-else) Input :
          input(type='checkbox' v-model='val')
        button(@click="dxResetBank") dxResetBank
  //- ================ dxSetBankInfo ========================
  .row
    .col-xs-12
      fieldset
        legend dxSetBankInfo
        div
          span Bank No
          input(type='number' v-model='apis.dxSetBankInfo.no' min='0' max='3')
        div(v-for="(key, val) in apis.dxSetBankInfo.outlets")
          span Outlet {{ key }} name:
          input(v-model='val.name')
        button(@click="dxSetBankInfo") dxSetBankInfo
</template>

<script>
  export default {
    data () {
      return {
        apis: {
          'dxEnableBank': {
            params: {
              banks: [false, false, true, false],
              enabled: false
            }
          },
          'dxLockBank': {
            params: {
              banks: [false, true, false, false],
              locked: false
            }
          },
          'dxResetBank': {
            params: {
              banks: [true, false, false, true]
            }
          },
          'dxSetBankInfo': {
            no: '1',
            outlets: [
              {name: 'amp', supplying: true},
              {name: 'TV', supplying: true},
              {name: 'PS4', supplying: true}
            ]
          }
        }
      }
    },
    methods: {
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxEnableBank () {
        this.sendAPI('dxEnableBank', {
          banks: this.apis.dxEnableBank.params.banks
            .map((enable, index) => enable ? index.toString() : null)
            .filter(v => v !== null),
          enabled: this.apis.dxEnableBank.params.enabled
        })
      },
      dxLockBank () {
        this.sendAPI('dxLockBank', {
          banks: this.apis.dxLockBank.params.banks
            .map((enable, index) => enable ? index.toString() : null)
            .filter(v => v !== null),
          locked: this.apis.dxLockBank.params.locked
        })
      },
      dxResetBank () {
        this.sendAPI('dxResetBank', {
          banks: this.apis.dxResetBank.params.banks
            .map((enable, index) => enable ? index.toString() : null)
            .filter(v => v !== null)
        })
      },
      dxSetBankInfo () {
        let newParams = {
          banks: {
            [this.apis.dxSetBankInfo.no]: {
              outlets: this.apis.dxSetBankInfo.outlets
            }
          }
        }
        this.sendAPI('dxSetBankInfo', newParams)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// power.vue?49da70fc